function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M54.4282 52.9962C54.2424 46.6341 42.548 48.0847 27.8932 48.0847C13.2383 48.0847 1.54392 46.6341 1.35816 52.9962C0.375379 61.8613 8.32439 62.8472 27.8932 62.8472C47.4619 62.8472 55.4109 61.8613 54.4282 52.9962Z",
  fill: "#FCCE59"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 3.40692,
  y: 25.3721,
  width: 48.9728,
  height: 5.53606,
  rx: 2.76803,
  fill: "#91A27C"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 3.40692,
  y: 32.6113,
  width: 48.9728,
  height: 5.11021,
  rx: 2.5551,
  fill: "#CC7B4E"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 3.40692,
  y: 39.4253,
  width: 48.9728,
  height: 5.53606,
  rx: 2.76803,
  fill: "#91A17C"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M55.7864 14.9121C55.7864 22.4139 43.2982 22.3682 27.8932 22.3682C12.4882 22.3682 0 22.4139 0 14.9121C0 6.67639 12.4882 0 27.8932 0C43.2982 0 55.7864 6.67639 55.7864 14.9121Z",
  fill: "#FCCE59"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M29.3612 6.30617C29.3612 7.07996 28.704 7.70724 27.8932 7.70724C27.0824 7.70724 26.4251 7.07996 26.4251 6.30617C26.4251 5.53238 27.0824 2.93604 27.8932 2.93604C28.704 2.93604 29.3612 5.53238 29.3612 6.30617Z",
  fill: "#FFF9C5"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M36.9678 4.97974C37.515 5.52689 37.4938 6.43521 36.9204 7.00853C36.3471 7.58184 35.4388 7.60305 34.8917 7.0559C34.3445 6.50875 32.9734 4.20809 33.5467 3.63477C34.12 3.06146 36.4207 4.43259 36.9678 4.97974Z",
  fill: "#FFF9C5"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M20.8948 7.05588C20.3477 7.60303 19.4394 7.58182 18.866 7.00851C18.2927 6.4352 18.2715 5.52688 18.8187 4.97973C19.3658 4.43258 21.6665 3.06144 22.2398 3.63476C22.8131 4.20807 21.442 6.50873 20.8948 7.05588Z",
  fill: "#FFF9C5"
});

function SvgHamberger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamberger);
export default __webpack_public_path__ + "static/media/hamberger.9e8ca34f.svg";
export { ForwardRef as ReactComponent };